require '../../seo-platform-editorial/frontend/editorial_widget'
require './modal'
require '../../helpers/frontend/json_response_handler'

$ ->

  # These two calls are inside a try/catch because they come from an external npm module.
  try
    # initialize GSM Editorial Widget
    Groupon.ui.GSMEditorialWidget.initWidget()
  catch err
    console?.log? err

$(window).load ->
  Groupon.Performance.pageReady()
